const dev = {
  api: {
    URL: 'https://api.elitenannies.com/v1',
  },
  auth: {
    CLIENT_ID: 'vY6QAr19496Im9nGxMlGXCy4T',
    CLIENT_SECRET: '66W1Tp3M1ZyRQDgCSr4XSv5t97Pyp7875hOCCHV1w3438098zi',
  },
};
const staging = {
  api: {
    URL: 'https://api.elitenannies.com/v1',
  },
  auth: {
    CLIENT_ID: 'vY6QAr19496Im9nGxMlGXCy4T',
    CLIENT_SECRET: '66W1Tp3M1ZyRQDgCSr4XSv5t97Pyp7875hOCCHV1w3438098zi',
  },
};

const production = {
  api: {
    URL: 'https://api.elitenannies.com/v1',
  },
  auth: {
    CLIENT_ID: 'vY6QAr19496Im9nGxMlGXCy4T',
    CLIENT_SECRET: '66W1Tp3M1ZyRQDgCSr4XSv5t97Pyp7875hOCCHV1w3438098zi',
  },
};

let config;

switch (process.env.REACT_APP_STAGE) {
  case 'staging':
    config = staging;
    break;
  case 'production':
    config = production;
    break;
  default:
    config = dev;
    break;
}
export default config;
